import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-black/10 bg-[#f0f0f5] py-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          <div className="col-span-2">
            <div className="flex items-center gap-4">
              <img
                src="/logo-transparent.png"
                alt="1st Choice Realty & Associates"
                className="h-24 w-auto"
              />
              <div className="font-display text-[#0a0a0a] tracking-widest text-sm uppercase">
                Sold By <span className="text-[#121275]">1st</span> Choice
              </div>
            </div>
            <p className="mt-6 text-black/50 max-w-md font-light">
              The brokerage built for producing agents. $3,500 flat per year, $150 per unit
              sold, best-in-class software. No franchise. No nonsense.
            </p>
          </div>
          <div>
            <div className="overline mb-5">Company</div>
            <ul className="space-y-3 text-black/60 text-sm">
              <li><a href="https://soldby1stchoice.com" target="_blank" rel="noreferrer" className="hover:text-[#0a0a0a]">Home</a></li>
              <li><Link to="/apply" className="hover:text-[#0a0a0a]">Apply</Link></li>
              <li><Link to="/admin/login" className="hover:text-[#0a0a0a]">Admin</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline mb-5">Contact</div>
            <ul className="space-y-3 text-black/60 text-sm">
              <li>join@soldby1stchoice.com</li>
              <li>916-794-0570</li>
              <li>7921 Kingswood Drive, Suite A3H</li>
              <li>Citrus Heights, CA 95610</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="numeric text-xs text-black/30 uppercase tracking-widest">
            © {new Date().getFullYear()} Sold By 1st Choice Realty Group. All rights reserved.
          </div>
          <div className="numeric text-xs text-black/30 uppercase tracking-widest">
            Privacy · Terms · CCPA
          </div>
        </div>
      </div>
    </footer>
  );
}
